import React from 'react';
import { Link } from 'react-router-dom';

const CopyBlock = ({ 
  imageUrl, 
  imageAlt, 
  headline, 
  copyText, 
  reversed = false,
  colorMode = "colorBlack",
  buttonLabel,
  buttonUrl
}) => {
  return (
    <section className="section">
      <div className="container">
        <div className={`columns is-vcentered is-variable is-8 ${reversed ? 'is-reversed' : ''}`}>
          {/* Image Column */}
          <div className="m-0 p-0 column is-three-fifths">
            <figure className="m-0 p-0 image">
              <img 
                src={imageUrl} 
                alt={imageAlt}
                style={{
                  border: '8px solid white',
                  borderRadius: '.25rem',
                  width: '100%',
                  height: 'auto',
                  boxShadow: '0 4px 4px rgba(0,0,0,0.01)'
                }}
                className="m-0 p-0 mobile-image"
              />
            </figure>
          </div>
          
          {/* Text Column */}
          <div className="my-0 py-0 column is-two-fifths">
            <div className="m-0 p-0 content">
              <h2 className={`mb-1 copy-block-heading ${colorMode}`}>
                {headline}
              </h2>
              <div className={`mt-2 copy-block-body ${colorMode}`}>
                {copyText}
              </div>
              <Link
                to={`${buttonUrl}`}
              >
                <button className='mt-5 button'>
                  {buttonLabel}
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CopyBlock;